import React, { useState, useEffect } from 'react';
import axios from 'axios';
import styles from './PlotList.module.scss';
import { useNavigate } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Navbar from './Navbar';

const PlotList = () => {

  const navigate = useNavigate();

  const [plots, setPlots] = useState([]);
  const [lastMesssages, setLastMessages] = useState([]);
  const [error, setError] = useState([]);
  const [filters, setFilters] = useState({
    deceasedFirstName: '',
    deceasedLastName: '',
    status: '',
    block: '',
    plotRow: '',
    grave: '',
    plotId: ''
  });
  const [currentPage, setCurrentPage] = useState(1);
  const plotsPerPage = 13; // Number of plots per page
  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchLastMessages = async () => {
        const token = localStorage.getItem('token');
      try {
        const lastMessagesRes = await axios.get(`${process.env.REACT_APP_URL}/messages/last`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        setLastMessages(lastMessagesRes.data); // Store the last messages
      } catch (err) {
        console.error('Failed to fetch last messages', err);
        setError('Failed to fetch last messages');
      }
    };

    fetchLastMessages()

    // if (token) {
    //   fetchLastMessages(); // Initial fetch
    //   const intervalId = setInterval(fetchLastMessages, 5000); // Fetch every 5 seconds

    //   return () => clearInterval(intervalId); // Clear the interval on component unmount
    // }
  }, [token]);

  useEffect(() => {
    const fetchPlots = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_URL}/plots`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setPlots(res.data);
      } catch (err) {
        console.error('Failed to fetch plots', err);
      }
    };

    fetchPlots();
  }, [token]);

  const deletePlot = async (plotId) => {
    try {
      await axios.delete(`${process.env.REACT_APP_URL}/plots/${plotId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setPlots(plots.filter(plot => plot.id !== plotId));
    } catch (err) {
      console.error('Failed to delete plot', err);
    }
  };

  // Filter plots based on the filter form inputs
  const filteredPlots = plots.filter(plot => {
    return (
      (filters.deceasedFirstName ? plot.deceasedFirstName?.toLowerCase().includes(filters.deceasedFirstName.toLowerCase()) : true) &&
      (filters.deceasedLastName ? plot.deceasedLastName?.toLowerCase().includes(filters.deceasedLastName.toLowerCase()) : true) &&
      (filters.status ? plot.status?.toLowerCase().includes(filters.status.toLowerCase()) : true) &&
      (filters.block ? plot.block?.toLowerCase().includes(filters.block.toLowerCase()) : true) &&
      (filters.plotRow ? plot.plotRow?.toLowerCase().includes(filters.plotRow.toLowerCase()) : true) &&
      (filters.grave ? plot.grave?.toLowerCase().includes(filters.grave.toLowerCase()) : true) &&
      (filters.plotId ? plot.plotId?.toLowerCase().includes(filters.plotId.toLowerCase()) : true)
    );
  });

  // Calculate the plots to display on the current page
  const indexOfLastPlot = currentPage * plotsPerPage;
  const indexOfFirstPlot = indexOfLastPlot - plotsPerPage;
  const currentPlots = filteredPlots.slice(indexOfFirstPlot, indexOfLastPlot);

  const totalPages = Math.ceil(filteredPlots.length / plotsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Calculate the pagination range
  const maxPageNumbers = 10;
  const startPage = Math.floor((currentPage - 1) / maxPageNumbers) * maxPageNumbers + 1;
  const endPage = Math.min(startPage + maxPageNumbers - 1, totalPages);

  // Handle filter input changes
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prevFilters => ({
      ...prevFilters,
      [name]: value
    }));
  };

  const view = (id) => {
    navigate(`/plots/view/${id}`)
  }

  const edit = (id) => {
    navigate(`/plots/edit/${id}`)
  }

  return (
    <div className="App">
      <Navbar />
      <div className="allContent">
        <Container fluid className='pb-5'>
          <Row className="justify-content-center">
            <Col xs="12" lg="12" className='mt-1'>
              <div className={styles.plotContainer}>
                {/* Filter Form */}
                <div className={styles.filterForm}>
                <input
                    type="text"
                    name="plotId"
                    placeholder="Plot ID"
                    value={filters.plotId}
                    onChange={handleFilterChange}
                    className={styles.filterInput}
                  />
                  <input
                    type="text"
                    name="deceasedFirstName"
                    placeholder="First Name"
                    value={filters.deceasedFirstName}
                    onChange={handleFilterChange}
                    className={styles.filterInput}
                  />
                  <input
                    type="text"
                    name="deceasedLastName"
                    placeholder="Last Name"
                    value={filters.deceasedLastName}
                    onChange={handleFilterChange}
                    className={styles.filterInput}
                  />
                  <input
                    type="text"
                    name="status"
                    placeholder="Status"
                    value={filters.status}
                    onChange={handleFilterChange}
                    className={styles.filterInput}
                  />
                  <input
                    type="text"
                    name="block"
                    placeholder="Block"
                    value={filters.block}
                    onChange={handleFilterChange}
                    className={styles.filterInput}
                  />
                  <input
                    type="text"
                    name="plotRow"
                    placeholder="Row"
                    value={filters.plotRow}
                    onChange={handleFilterChange}
                    className={styles.filterInput}
                  />
                  <input
                    type="text"
                    name="grave"
                    placeholder="Grave"
                    value={filters.grave}
                    onChange={handleFilterChange}
                    className={styles.filterInput}
                  />
                </div>

                <table className={styles.plotTable}>
                  <thead>
                    <tr>
                      <th>Plot ID</th>
                      <th>First Name</th>
                      <th>Last Name</th>
                      <th>Status</th>
                      <th>Block</th>
                      <th>Row</th>
                      <th>Grave</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentPlots.map(plot => (
                      <tr key={plot.id}>
                        <td>{plot.plotId}</td>
                        <td>{plot.deceasedFirstName}</td>
                        <td>{plot.deceasedLastName}</td>
                        <td>{plot.status}</td>
                        <td>{plot.block}</td>
                        <td>{plot.plotRow}</td>
                        <td>{plot.grave}</td>
                        <td>
                          <button onClick={() => view(plot.id)} className={styles.actionButton}>View</button>
                          <button onClick={() => edit(plot.id)} className={styles.actionButton}>Edit</button>
                          <button onClick={() => deletePlot(plot.id)} className={`${styles.actionButton} ${styles.deleteButton}`}>Delete</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <div className={styles.pagination}>
                  {startPage > 1 && (
                    <button onClick={() => handlePageChange(startPage - maxPageNumbers)}>
                      &laquo; Prev
                    </button>
                  )}
                  {Array.from({ length: endPage - startPage + 1 }, (_, index) => (
                    <button
                      key={startPage + index}
                      onClick={() => handlePageChange(startPage + index)}
                      className={startPage + index === currentPage ? styles.activePage : ''}
                    >
                      {startPage + index}
                    </button>
                  ))}
                  {endPage < totalPages && (
                    <button onClick={() => handlePageChange(endPage + 1)}>
                      Next &raquo;
                    </button>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default PlotList;
